module.exports = __webpack_public_path__ + "images/emoji/police_car.302a67584e7cc9a28f14.png";